module.exports = __webpack_public_path__ + "img/ESD-machine-min.57ba73c0.jpg";